import Services from '../../services'

class AuthApi {
  login(value) {
    return Services.post('/ang/auth/login', value)
  }
}

export default new AuthApi()